import type { PlanComparison as PlanComparisonData } from "@/services/migration";

interface Props {
  plan: PlanComparisonData;
  onConfirm: () => void;
  onBack: () => void;
}

export const PlanComparison: React.FC<Props> = ({ plan, onConfirm, onBack }) => {
  const tiers = plan.currentPlan.tiers;

  return (
    <div className="page">
      <div className="page__inner page__inner--wide">
        <div className="logo-text">Vammo</div>

        <span className="eyebrow">Sua comparação</span>
        <h1 className="title">
          Olá, <span className="accent">{plan.user.firstName}</span>.<br />
          Veja como fica seu plano.
        </h1>
        <p className="subtitle">
          Moto: <strong>{plan.user.vehicleModel}</strong>
          <br />
          Periodicidade: <strong>{plan.user.periodicity}</strong>
        </p>

        <div className="comparison">
          {/* Plano atual */}
          <div className="plan-card">
            <div className="plan-card__label">Plano atual</div>
            <div className="plan-card__periodicity">{plan.user.periodicity}</div>

            <div className="plan-section">
              <div className="plan-section__header">Assinatura fixa</div>
              <div className="plan-fixed">
                <span className="plan-fixed__value">
                  R$ {plan.currentPlan.fixedValue}
                </span>
              </div>
            </div>

            <div className="plan-section">
              <div className="plan-section__header">Cobrança variável</div>
              <table className="tier-table">
                <thead>
                  <tr>
                    <th>Faixa de km</th>
                    <th style={{ textAlign: "right" }}>Preço por km</th>
                  </tr>
                </thead>
                <tbody>
                  {tiers.map((tier, idx) => (
                    <tr key={`${tier.range}-${idx}`}>
                      <td>{tier.range}</td>
                      <td>R$ {tier.rate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Plano novo */}
          <div className="plan-card plan-card--new">
            <div className="plan-card__label">Novo plano</div>
            <div className="plan-card__periodicity">{plan.user.periodicity}</div>

            <div className="plan-section">
              <div className="plan-section__header">Assinatura fixa</div>
              <div className="plan-fixed">
                <span className="plan-fixed__value">
                  R$ {plan.newPlan.fixedValue}
                </span>
              </div>
            </div>

            <div className="plan-section">
              <div className="plan-section__header">Cobrança variável</div>
              <div className="plan-linear">
                <span className="plan-linear__value">
                  R$ {plan.newPlan.linearRate}/km
                </span>
                <span className="plan-linear__hint">
                  Pague por km. Preço único, sem faixas.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="disclaimer">
          <p className="disclaimer__intro">
            Esta migração online <strong>não cobre</strong> os casos abaixo:
          </p>
          <ul className="disclaimer__list">
            <li>
              Mudar a <strong>periodicidade</strong> do plano (ex: de Anual para
              Mensal).
            </li>
            <li>
              Trocar o <strong>modelo de moto</strong> contratado.
            </li>
            {plan.user.planFamily === "comfort" && (
              <li>
                Migrar para o <strong>plano ilimitado (Comfort)</strong>.
              </li>
            )}
          </ul>
          <p className="disclaimer__outro">
            Para esses casos, fale direto com o nosso atendimento no{" "}
            <a
              href="https://wa.me/+5511987826794"
              target="_blank"
              rel="noopener"
            >
              (11) 98782-6794
            </a>
            .
          </p>
        </div>

        <div className="comparison-cta">
          <button
            type="button"
            className="btn btn--primary"
            onClick={onConfirm}
          >
            Quero migrar para o novo plano
          </button>
          <button type="button" className="btn btn--ghost" onClick={onBack}>
            Decidir depois
          </button>
        </div>
      </div>
    </div>
  );
};
